import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { BackButton } from "../../globalStyles/CommonStyles";

const FooterContainer = styled.div`
  display:grid;
  gap:16px;
  grid-template-columns: auto max-content;
  align-items: center;
  padding: 8px;

  p{    
    font-size: 1.5rem;
    opacity: 0.8;
  }
  
  ${BackButton}{
    height: 40px;
  }
`

const Footer = () => {
  const history = useHistory();

  return (
    <FooterContainer>
    <p>¿Te gusta esta web app?</p>
    <BackButton type="button" onClick={() => history.push("/interested")}>
    Comentarios / Contactar
      </BackButton>
  </FooterContainer>
  );
};

export default Footer;
